import {
  DatagridConfigurable,
  email,
  ExportButton,
  FilterButton,
  List,
  SelectColumnsButton,
  SelectInput,
  TextInput,
  TopToolbar,
} from 'react-admin';
import { genericCSVExporter } from '@/util/genericCSVExporter';

import { DefaultPagination } from '@/components/DefaultPagination';
import {
  renderExportColumns,
  renderGridColumns,
} from '@/components/ConfigurableColumns';
import { patientsColumns } from './patientsColumns';

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
    <ExportButton
      maxResults={1000000}
      exporter={documentsCsvExporter}
    />
  </TopToolbar>
);

const defaultDeletedAtFilter = {
  $$raw: JSON.stringify({ $eq: null }),
};

const emailValidation = [email()];

const filters = [
  <TextInput
    key="therapistId"
    defaultValue=""
    source="therapistId"
    label="Therapist Id"
  />,
  <TextInput
    key="promoCodeId"
    defaultValue=""
    source="promoCodeId"
    label="Promo Code"
  />,
  <TextInput
    label="Connection Id"
    key="id"
    source="_id"
    defaultValue=""
    parse={(val: any) =>
      val
        ? {
            $oid: val,
          }
        : ''
    }
    format={(val: any) => {
      console.log('FORMAT', val);

      return val?.$oid || '';
    }}
  />,
  <TextInput
    label="Email"
    key="therapistEmail"
    source="therapistEmail"
    validate={emailValidation}
    defaultValue=""
  />,
  <TextInput
    key="therapistFirstName"
    defaultValue=""
    source="therapistFirstName"
    label="First Name"
  />,
  <TextInput
    key="therapistLastName"
    defaultValue=""
    source="therapistLastName"
    label="Last Name"
  />,
  <SelectInput
    key="deletedAt"
    label="Deleted Items"
    source="deletedAt"
    alwaysOn
    emptyText="Hidden"
    emptyValue="hidden"
    choices={[
      // { id: "hidden", name: "Hidden" },
      { id: 'visible', name: 'Visible' },
      { id: 'only', name: 'Only' },
    ]}
    format={value => {
      if (!value) {
        return 'hidden';
      }

      return value;
    }}
  />,
  <SelectInput
    key="isHiddenTestAccount"
    label="Test Accounts"
    source="isHiddenTestAccount"
    emptyText="Hidden"
    emptyValue="hidden"
    alwaysOn
    choices={[
      // { id: "hidden", name: "Hidden" },
      { id: 'visible', name: 'Visible' },
      { id: 'only', name: 'Only' },
    ]}
    format={value => {
      if (!value) {
        return 'hidden';
      }

      return value;
    }}
  />,
];

export const TherapistPatientsList = () => (
  <List
    perPage={25}
    filters={filters}
    actions={<ListActions />}
    pagination={<DefaultPagination />}
    sort={{ field: 'createdAt', order: 'DESC' }}
  >
    <DatagridConfigurable
      bulkActionButtons={false}
      omit={['isTestPatient']}
    >
      {renderGridColumns(patientsColumns)}
      {/* <CopiableIdDataGridField
        label="Connection Id"
        copyLink
        targetNavigationResource="therapistPatients"
        formatFilter={(_id: any) => ({ $oid: _id })}
      />
      <DateField showTime label="Created At" source="createdAt" />
      <CopiableIdDataGridField
        label="Therapist Id"
        source="therapistId"
        targetNavigationResource="therapists"
        filter={["therapistId"]}
      />
      <EmailField label="Therapist Email" source="therapistEmail" />
      <TextField label="Therapist Title" source="therapistTitle" />
      <TextField label="Therapist First Name" source="therapistFirstName" />
      <TextField label="Therapist Last Name" source="therapistLastName" />
      <CopiableIdDataGridField
        label="Connected Patient Id"
        source="patientId"
      />
      <FunctionField
        label="Connected At"
        source="patientConnectedAt"
        render={(patient: any) =>
          patient.patientConnectedAt ? (
            <GenericRelativeDateDisplay date={patient.patientConnectedAt} />
          ) : null
        }
      />
      <FunctionField
        label="Disconnected At"
        source="patientDisconnectedAt"
        render={(patient: any) =>
          patient.patientDisconnectedAt ? (
            <GenericRelativeDateDisplay date={patient.patientDisconnectedAt} />
          ) : null
        }
      />
      <FunctionField
        label="Client Type"
        source="isTestPatient"
        render={(patient: any) => (
          <Chip
            label={
              typeof patient.isTestPatient === "boolean"
                ? patient.isTestPatient
                  ? "Onboarding"
                  : "Regular/Converted"
                : "Regular"
            }
          />
        )}
      />
      <DateField label="Deleted At" showTime source="deletedAt" /> */}
    </DatagridConfigurable>
  </List>
);

const documentsCsvExporter = genericCSVExporter(
  'therapistPatients',
  renderExportColumns(patientsColumns),
);
